exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-da-tsx": () => import("./../../../src/pages/index.da.tsx" /* webpackChunkName: "component---src-pages-index-da-tsx" */),
  "component---src-pages-index-no-tsx": () => import("./../../../src/pages/index.no.tsx" /* webpackChunkName: "component---src-pages-index-no-tsx" */),
  "component---src-pages-index-sv-tsx": () => import("./../../../src/pages/index.sv.tsx" /* webpackChunkName: "component---src-pages-index-sv-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

